module.exports = __webpack_public_path__ + "img/PLUS.7073afc1.svg";